import * as types from "../types";

const initialState = {
    loading: false,
    loginReq: null,
    loginResult: null,
    error: null
}

export default function loginReducer(state = initialState, action){
    
    switch(action.type){

        case types.LOGIN_REQUEST :
            return{
                ...state,
                loading: true,
                loginReq: action.payload.loginReq,
            }

        case types.LOGIN_SUCCESS :
            return{
                ...state,
                loading: false,
                loginResult: action.payload.loginResult,
            }

        case types.LOGIN_FAILURE :
            return{
                ...state,
                loading: false,
                loginReq: null,
                loginResult: null,
                error: action.payload.error
            }


        case types.LOGOUT_REQUEST :
            return{
                ...state,
                loading: true,
            }


        case types.LOGOUT_SUCCESS :
            return{
                ...state,
                loading: false,
                loginReq: null,
                loginResult: null,
                error: null
            }


        default :
        return state;

    }

}